import React from "react";
import {Toast} from "xps-react";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {
    selectShowDuplicateSuccessToast,
    setShowDuplicateSuccessToast,
} from "./RecentlyDuplicatedSampleSlice";

const DuplicateSuccessToast = () => {
    const dispatch = useAppDispatch();
    const showDuplicateSuccessToast = useAppSelector(selectShowDuplicateSuccessToast);

    if (!showDuplicateSuccessToast) {
        return null;
    }

    return <div className="duplicate-success-toast">
        <Toast
            title="National Sample successfully duplicated."
            message="You can now view, edit, and present the profile via the My Samples record."
            iconName="status_validated"
            onClose={() => dispatch(setShowDuplicateSuccessToast(false))}
            showCloseBtn={true}
            theme="light"
            type="success"
            width={360}
        />
    </div>;
};

export default DuplicateSuccessToast;
